/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import { DAYS, MONTHS, YEARS } from '../enums/DurationUnits.mjs'

const MandateAndEstateSchema = new Schema({
  mandateId: {
    type: 'number'
  },
  estateId: {
    type: 'number'
  }
})

const MandateSchema = new Schema({
  agencyFees: {
    type: 'number',
    min: 0
  },
  isAgencyFeesWithTax: {
    type: 'boolean',
    required: true
  },
  managementFees: {
    type: 'number',
    min: 0
  },
  isManagementFeesWithTax: {
    type: 'boolean',
    required: true
  },
  number: {
    type: 'integer',
    required: true
  },
  type: {
    type: 'string',
    required: true,
    allowed: ['R', 'GL', 'LC', 'LS', 'VE', 'VS']
  },
  duration: {
    type: 'number',
    min: 0,
    required: true
  },
  durationUnit: {
    type: 'string',
    allowed: [YEARS, MONTHS, DAYS],
    required: true
  },
  startDate: {
    type: 'string',
    format: 'date-time',
    required: true
  },
  renewalDate: {
    type: 'string',
    format: 'date-time'
  },
  endDate: {
    type: 'string',
    format: 'date-time'
  },
  price: {
    type: 'number',
    min: 0
  },
  securityDeposit: {
    type: 'number',
    min: 0
  },
  customerId: {
    type: 'number',
    required: true
  },
  MandateAndEstate: {
    type: 'array',
    items: {
      type: MandateAndEstateSchema
    }
  }
})

export default MandateSchema
